import { KnownGroupRegistrationPolicy } from '@groundfloor-platform/mgmt-service-g-sdk';

/** The raw values mislead: "restricted" means invitation only, "open" means self registration. */
export const registrationPolicyToLabel: Record<string, string> = {
  [KnownGroupRegistrationPolicy.Hidden]: 'Hidden',
  [KnownGroupRegistrationPolicy.Restricted]: 'Invitation only',
  [KnownGroupRegistrationPolicy.Open]: 'Self registration'
};
